<template>
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <data-grid
            :showSum="false"
              ref="grid"
              stripe
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              :columns="[
                { title: $t('ItemCode'), sort: 'ItemCode' },
                { title: $t('Count'), sort: 'Count' ,total: 'totalPackingCount', },
                { title: $t('NetWeight') },
                { title: $t('GrossWeight') },
                { title: $t('CountyOfRegion') },
                { title: $t('CountInEachCartoon') },
                { title: $t('TotalNetWeight') ,total: 'totalNetWeight',},
                { title: $t('TotalGrossWeight') ,total: 'totalGrossWeight', },
                { title: $t('CountOfCartoons')  ,total: 'totalCountOfCartoons', },
                { title: $t('PalletNumber')  ,total: 'totalPalletNumber',},
                { title: $t('PalletWeight') ,total: 'totalPalletWeight',},
              ]"
            >
              <template slot-scope="{ row }">
                <td>
                  {{ row.itemCode ? row.itemCode : "-" }}
                </td>
                <td>
                  {{ row.count ? row.count : "-" }}
                </td>
                <td>
                  {{ row.netWeight ? row.netWeight : "-" }}
                </td>
                <td>
                    {{ row.grossWeight ? row.grossWeight : "-" }}
                </td>
                <td>
                    {{ row.countyOfRegion ? row.countyOfRegion : "-" }}
                </td>
                <td>
                    {{ row.countInEachCartoon ? row.countInEachCartoon : "-" }}
                </td>
                <td>
                    {{ row.totalNetWeight ? row.totalNetWeight : "-" }}
                </td>
                <td>
                    {{ row.totalGrossWeight ? row.totalGrossWeight : "-" }}
                </td>
                <td>
                    {{ row.countOfCartoons ? row.countOfCartoons : "-" }}
                </td>
                <td>
                    {{ row.palletNumber ? row.palletNumber : "-" }}
                </td>
                <td>
                    {{ row.palletWeight ? row.palletWeight : "-" }}
                </td>
              </template>
            </data-grid>
          </div>
        </div>
      </div>
    </div>
  </template>
  <script>
  import DataGrid from "@/components/datagrid/DataGrid";
  
  export default {
    components: {
      DataGrid,
    },
    data() {
      return {
        permission:
          "GotoReject|GotoClose|GetPurchaseInvoiceById|UpdateDeductionAndIncreasesOfPurchaseInvoice|UpdateCurrencyInfoCommand",
        gridDataSource: {
          type: "app",
          service: "Shipping/api/ReceiveShipmentsQuery/packing-lists/" + this.$route.params.id,
        },
        gridSearchData: {},
      };
    },
    methods: {
      editPurchaseRequest(model) {},
      deletePurchaseRequest(id) {},
    },
  };
  </script>
  